(function () {
    'use strict';

    angular
        .module('highSchoolVisit')
        .controller('HighSchoolVisitExhibitorAccommodationController', HighSchoolVisitExhibitorAccommodationController);

        HighSchoolVisitExhibitorAccommodationController.$inject = ['HighSchoolVisitService','CitiesByExpoService','$timeout'];

    function HighSchoolVisitExhibitorAccommodationController(HighSchoolVisitService,CitiesByExpoService,$timeout) {
        var vm = this;

        vm.flag                  = false;
        vm.expos                 = [];
        vm.selectExpo            = selectExpo;
        vm.selectCitiesByExpo    = selectCitiesByExpo;
        vm.expoSelected          = '';
        vm.citySelected          = '';
        vm.getByFilter           = getByFilter;
        vm.getByFilterCsv        = getByFilterCsv;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;

        activate();

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        function activate() {
            vm.selectExpo();
        }

        function selectExpo () {
            vm.query = {};
            HighSchoolVisitService.getExpos(vm.query).then(function(response){
                vm.expos = response.data;
            });
        }

        function selectCitiesByExpo () {
            vm.cities = [];
            CitiesByExpoService.getCities(vm.expoSelected).then(function(response){
                vm.cities       = response.data;
                vm.cities.unshift({expo_location_id : '', city_name : '--- All ---'});
                vm.citySelected = '';
            });
        }

        function getByFilter () {
            let query           = {};
            vm.flag             = false;
            query['page']       = vm.page;
            query['expo_id']    = vm.expoSelected;
            if(vm.citySelected != '') {
                query['expo_location_id'] = vm.citySelected;
            }
            HighSchoolVisitService.getExpoUserAccommodations(query).then(function(response) {
                vm.flag = true;
                vm.accommodations = response.data.data;
                vm.totalItems = response.data.total;
                vm.itemsPerPage = response.data.per_page;
                vm.setPage(response.data.current_page);
            }).catch(function(err) {
            });
        }

        function getByFilterCsv () {
            let query           = {};
            query['page']       = vm.page;
            query['expo_id']    = vm.expoSelected;
            HighSchoolVisitService.getExpoUserAccommodationsCsv(query).success(function(data, status, headers, config) {
                var anchor = document.createElement('a');
                anchor.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(data);
                anchor.target = '_blank';
                anchor.download = 'high_school_tours_accommodations_' + vm.expoSelected + '_' + vm.citySelected + '.csv';
                document.body.appendChild(anchor);
                anchor.click();
                $timeout(function () {
                    anchor.remove();
                }, 50);
            });
        }
    }

})();